export default __webpack_public_path__ + "static/media/ic-practice-test.6978e9c6.svg";